// extracted by mini-css-extract-plugin
export var smallSpinner = "_r8-0";